var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('SendGiftMenu',{attrs:{"header":"Send Gifts"}}),(
      !_vm.isLoading &&
      _vm.remainingShipments === 0 &&
      _vm.availableAdditionalOrders === 0
    )?_c('NoGiftAvailable'):_vm._e(),_c('ProductGallery'),_c('BundlesGallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }